module.exports = __webpack_public_path__ + "static/media/bg27.7556d0eb.jpg";